"use client";

import { cn } from "@/lib/utils";
import type { Filters } from "@/types/images-categories.types";
import { Button } from "./ui/button";

type Props = {
  label: string;
  value: Filters;
  selected: boolean;
  onSelect: (filter: Filters) => void;
};

export function MainGalleryFilterOption({
  label,
  value,
  selected,
  onSelect,
}: Props) {
  return (
    <Button
      className={cn(
        "shadow-none bg-brand-800/30 w-full py-4 lg:py-0 lg:w-auto hover:bg-brand-800 h-full cursor-pointer",
        selected && "bg-brand-800",
      )}
      onClick={() => onSelect(value)}
    >
      <h2 className="text-sm tracking-[-0.02em] leading-[110%] font-medium text-background">
        {label}
      </h2>
    </Button>
  );
}
